export default "__VITE_ASSET__BVV$poig__"